import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import { useMutation } from 'urql';
import DestructiveAction, {
  DestructiveActionHeading,
} from '@/components/Custom/DestructiveAction';
import ContentBoundary from '@/components/UI/ContentBoundary';
import EmptyPlaceholder from '@/components/UI/EmptyPlaceholder';
import { graphql } from '@/gql/graphql';
import useUserId from '@/hooks/useUserId';

const LeaveChat = graphql(/* GraphQL */ `
  mutation LeaveChat($chatId: uuid!, $personId: String!) {
    delete_chat_person_by_pk(chat_id: $chatId, person_id: $personId) {
      person_id
      chat_id
    }
  }
`);

export default function ChatLeave() {
  const personId = useUserId();
  const { chatId, title } = useLocalSearchParams();
  const { back } = useRouter();
  const [, leaveChat] = useMutation(LeaveChat);

  const onPressLeave = async (chatId: string) => {
    const result = await leaveChat({ personId, chatId });
    if (result.error || !result.data?.delete_chat_person_by_pk)
      return { success: false };
    return { success: true };
  };

  return (
    <>
      <Stack.Screen options={{ title: `Leave ${title}` }} />
      <ContentBoundary
        data={typeof chatId === 'string' ? chatId : null}
        empty={<EmptyPlaceholder message="Leaving is unavailable." />}
      >
        {(chatId) => (
          <DestructiveAction
            key={chatId}
            label="Leave Chat"
            submittingLabel="Leaving…"
            testID="ChatDetailInfoLeaveConfirmButton"
            onAction={() => onPressLeave(chatId)}
            onSuccess={() => {
              back();
              back();
              back();
            }}
          >
            <DestructiveActionHeading>
              Are you sure you want to leave this Chat?
            </DestructiveActionHeading>
          </DestructiveAction>
        )}
      </ContentBoundary>
    </>
  );
}
